module.exports = __webpack_public_path__ + "img/default-img.37148c3d.svg";